export function xor(a?: boolean, b?: boolean) {
    return !a !== !b;
}
